/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectTaxesTaxPrmsEnumsRetrieve } from '../fn/taxes-enums/project-taxes-tax-prms-enums-retrieve';
import { ProjectTaxesTaxPrmsEnumsRetrieve$Params } from '../fn/taxes-enums/project-taxes-tax-prms-enums-retrieve';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesEnumsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxPrmsEnumsRetrieve()` */
  static readonly ProjectTaxesTaxPrmsEnumsRetrievePath = '/api/project_taxes/tax_prms/enums/{project_id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsEnumsRetrieve$Response(
    params: ProjectTaxesTaxPrmsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesTaxPrmsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsEnumsRetrieve(
    params: ProjectTaxesTaxPrmsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectTaxesTaxPrmsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
